import { idb } from "./indexDBHelper"
import { DB_NAME, DB_VERSION, STORES_SCHEMA, STORE_MAP, STORES_METHODS_MAP } from "../config/cache/cache-engine"
import { stringifyData, parseData } from '../helpers/utilsHelper'

// Private methods to communicate with data base
function _initStorages(DB) {
	Object.entries(STORES_SCHEMA).forEach(([storeName, fiedls]) => {
		idb.createStore(DB, storeName, {
			keyPath: fiedls.KEY
		})
	})
}

async function _initEngine() {
	const DB = await idb.openDB(DB_NAME, DB_VERSION, {
		onUpgradeNeeded: _initStorages
	})

	return DB
}

async function _getFromStorage(DB, storeName, key) {
	try {
		const rawData = await idb.getByKeyPath(DB, storeName, key)
		return rawData?.[STORES_SCHEMA[storeName].DATA]
	} catch (error) {
		console.error(error)
		return null
	}
}

async function _setToStorage(DB, storeName, key, value) {
	try {
		return await idb.storeAction(DB, storeName, {
			action: 'put',
			object: {
				[STORES_SCHEMA[storeName].KEY]: key,
				[STORES_SCHEMA[storeName].DATA]: value
			}
		})
	} catch (error) {
		console.error(error)
	}
}

// Private methods to communicate with storages

function _getVersion(DB, key) {
	return _getFromStorage(DB, STORE_MAP.VERSION, key)
}

function _setVersion(DB, key, version) {
	return _setToStorage(DB, STORE_MAP.VERSION, key, version)
}

function _getFromSimple(DB, key) {
	return _getFromStorage(DB, STORE_MAP.SIMPLE, key)
}

function _setToSimple(DB, key, data) {
	return _setToStorage(DB, STORE_MAP.SIMPLE, key, data)
}

function _getFromLevelBase(DB, key) {
	return _getFromStorage(DB, STORE_MAP.BASE, key)
}

function _setToLevelBase(DB, key, data) {
	return _setToStorage(DB, STORE_MAP.BASE, key, data)
}

function _getFromLevelExtended(DB, key) {
	return _getFromStorage(DB, STORE_MAP.EXTENDED, key)
}

function _setToLevelExtended(DB, key, data) {
	return _setToStorage(DB, STORE_MAP.EXTENDED, key, data)
}

function _getFromLevelFull(DB, key) {
	return _getFromStorage(DB, STORE_MAP.FULL, key)
}

function _setToLevelFull(DB, key, data) {
	return _setToStorage(DB, STORE_MAP.FULL, key, data)
}


// Export of function which returns cache engine interface, using private methods
// Methods of this inteface includes additional data transforming and data checking before sending it to base, or getting data from it
export default async function() {
	const DataBase = await _initEngine()

	async function getVersion(key) {
		return _getVersion(DataBase, key)
	}

	async function setVersion(key, version) {
		return _setVersion(DataBase, key, version)
	}

	async function getFromSimple(key) {
		const result = await _getFromSimple(DataBase, key)
		const transfrormedData = parseData(result)

		return transfrormedData
	}

	async function setToSimple(key, data) {
		const transfrormedData = stringifyData(data)
		const result = await _setToSimple(DataBase, key, transfrormedData)

		return result
	}

	async function getFromLevelBase(key) {
		const result = await _getFromLevelBase(DataBase, key)
		const transfrormedData = parseData(result)

		return transfrormedData
	}

	async function setToLevelBase(key, data) {
		const transfrormedData = stringifyData(data)
		const result = await _setToLevelBase(DataBase, key, transfrormedData)

		return result
	}

	async function getFromLevelExtended(key) {
		const result = await _getFromLevelExtended(DataBase, key)
		const transfrormedData = parseData(result)

		return transfrormedData
	}

	async function setToLevelExtended(key, data) {
		const transfrormedData = stringifyData(data)
		const result = await _setToLevelExtended(DataBase, key, transfrormedData)

		return result
	}

	async function getFromLevelFull(key) {
		const result = await _getFromLevelFull(DataBase, key)
		const transfrormedData = parseData(result)

		return transfrormedData
	}

	async function setToLevelFull(key, data) {
		const transfrormedData = stringifyData(data)
		const result = await _setToLevelFull(DataBase, key, transfrormedData)

		return result
	}

	return {
		[STORES_METHODS_MAP[STORE_MAP.VERSION].GET]: getVersion,
		[STORES_METHODS_MAP[STORE_MAP.VERSION].SET]: setVersion,
		[STORES_METHODS_MAP[STORE_MAP.SIMPLE].GET]: getFromSimple,
		[STORES_METHODS_MAP[STORE_MAP.SIMPLE].SET]: setToSimple,
		[STORES_METHODS_MAP[STORE_MAP.BASE].GET]: getFromLevelBase,
		[STORES_METHODS_MAP[STORE_MAP.BASE].SET]: setToLevelBase,
		[STORES_METHODS_MAP[STORE_MAP.EXTENDED].GET]: getFromLevelExtended,
		[STORES_METHODS_MAP[STORE_MAP.EXTENDED].SET]: setToLevelExtended,
		[STORES_METHODS_MAP[STORE_MAP.FULL].GET]: getFromLevelFull,
		[STORES_METHODS_MAP[STORE_MAP.FULL].SET]: setToLevelFull
	}
}